"use client";

import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/app/components/shadcn/breadcrumb";
import { ProductBreadcrumb as ProductBreadcrumbType } from "@/app/lib/features/productDetail/productDetail.types";

const ProductDetailBreadcrumb = () => {
  const { breadcrumbs } = useProductDetail();

  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbs.map((item: ProductBreadcrumbType, index: number) => (
          <div key={index} className="flex items-center gap-2">
            <BreadcrumbItem>
              <BreadcrumbLink 
                href={item.type === "home" ? "/" : item.slug ? `/${item.slug}` : "#"}
                className={item.type === "product" ? "font-medium text-black" : ""}
              >
                {item.title}
              </BreadcrumbLink>
            </BreadcrumbItem>
            {index < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
          </div>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default ProductDetailBreadcrumb;
